import React, { useState, useContext, useEffect, useRef } from 'react'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import { setCurrentSection } from '@state/actions/appActions'
import { useUpdateSection } from '@hooks/mutations/useUpdateSection'
import {
  PANELS,
  DIVIDER_SIZE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  HEADING_TYPE,
  COLORS,
  TEXT_SIZES,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Button from '@components/Button'
import Text from '@components/Text'
import Divider from '@components/Divider'
import Editor from '@components/Editor'
import BlockRenderer from '@views/BlockRenderer'
import ButtonWithLoader from '@components/ButtonWithLoader'
import dayjs from 'dayjs'

const TeachersGuidePanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    app: { editMode, currentSection },
  } = state

  const [hasMounted, setHasMounted] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  const editorRef = useRef()

  const { post, isPosting } = useUpdateSection()

  const save = async () => {
    try {
      const currentContent = await editorRef.current.getContent()

      if (currentContent) {
        const currentContentStr = JSON.stringify(currentContent)

        const res = await post(
          {
            id: currentSection.id,
            teachersGuideContent: currentContentStr,
          },
          'Lärarhandledning uppdaterad.',
          'Nåt gick fel när vi skulle uppdatera lärarhandledning.'
        )

        if (res.success) {
          setIsDirty(false)
          // TODO, Should we close panel here?
          // TODO, Should we quity edit state here?
          // dispatch(closePanel(PANELS.TEACHERS_GUIDE))
        }
      } else {
        console.log('🚀 ~ editor not ready for save')
      }
    } catch (error) {
      console.log('🚀 ~ error saving', error)
    }
  }

  const onChange = async () => {
    if (!isDirty) setIsDirty(true)
    const currentContent = await editorRef.current.getContent()
    const updatedSection = {
      ...currentSection,
      teachersGuideContent: JSON.stringify(currentContent),
    }

    dispatch(setCurrentSection(updatedSection))
  }

  return (
    <div>
      <div className={'flex justify-between'}>
        <div className={'grid grid-rows-2 grid-cols-2 gap-1 w-full'}>
          <Text
            color={COLORS.DARK_GREY.TEXT}
            size={TEXT_SIZES.XXXSMALL}
            uppercase
          >
            Avsnitt senast ändrat: {dayjs(currentSection.updated_at).format('YYYY-MM-DD')}
          </Text>

          <Text
            color={COLORS.DARK_GREY.TEXT}
            size={TEXT_SIZES.XXXSMALL}
            uppercase
          >
            Årskurs: {currentSection.schoolYear.name}
          </Text>
          <Text
            color={COLORS.DARK_GREY.TEXT}
            size={TEXT_SIZES.XXXSMALL}
            uppercase
          >
            Nivå: {currentSection.level.name}
          </Text>
        </div>

        <Button
          size={BUTTON_SIZE.NO_PADDING}
          icon={'Close'}
          handleClick={() => dispatch(closePanel(PANELS.TEACHERS_GUIDE))}
        />
      </div>

      {editMode && (
        <>
          <Divider size={DIVIDER_SIZE.SMALL} />
          <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.LARGE}>
            Rekommendationer för det här avsnittet
          </Heading>
          <Divider size={DIVIDER_SIZE.SMALL} />
          <Text>
            Här kan du vägleda någon annan som väljer att jobba med ditt avsnitt
          </Text>
        </>
      )}
      <Divider size={DIVIDER_SIZE.SMALL} line />
      <Divider size={DIVIDER_SIZE.SMALL} />

      {editMode && hasMounted ? (
        <Editor
          ref={editorRef}
          content={currentSection.teachersGuideContent}
          onSave={save}
          elementId={'editorjsTeacher'}
          exercises={false}
          onChange={onChange}
        />
      ) : currentSection?.teachersGuideContent ? (
        <BlockRenderer content={currentSection.teachersGuideContent} />
      ) : (
        <Text>Det här avsnittet har ingen lärarhandledning.</Text>
      )}

      {editMode && (
        <div className={'flex items-center'}>
          <div className={'mr-4'}>
            {/* Previous button with icon */}
            {/* Perhaps button with loader should support icon? */}

            {/* <Button
              handleClick={save}
              textColor={COLORS.WHITE.TEXT}
              backgroundColor={COLORS.PRIMARY_GREEN.BACKGROUND}
              type={BUTTON_TYPE.PRIMARY}
              size={BUTTON_SIZE.LARGE}
              icon={'ClipboardAdd'}
              iconLeft
            >
              Spara
            </Button> */}

            <ButtonWithLoader
              type={BUTTON_TYPE.PRIMARY}
              isLoading={isPosting}
              disabledText={'Spara'}
              enabledText={'Spara'}
              disabled={isPosting || !isDirty}
              handleClick={save}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default TeachersGuidePanel
